/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import HelpIcon from '@mui/icons-material/Help';
import { Box, Button, Card, CardContent, FormControl, InputAdornment, InputLabel, MenuItem, Modal, Select, TextField, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { createTheme } from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { fetchContactReportDetails } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";

const SCREEN_NAME = "Contact Reports";
let SCREEN_RIGHT;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'grid',
    justifyContent: 'center'
};

createTheme(
    'solarized',
    {
        text: {
            primary: 'white',
            secondary: 'white',
        },
        background: {
            default: '#202940',
        },
        context: {
            background: '#202940',
            text: 'white',
        },
        divider: {
            default: 'white',
        },

        sortFocus: {
            default: '#2aa198',
        },
    },
    'dark',
);
createTheme(
    'light',
    {
        text: {
            primary: 'black',
            secondary: 'black',
        },
        background: {
            default: 'white',
        },
        context: {
            background: 'white',
            text: 'black',
        },
        divider: {
            default: 'gray',
        },
        sortFocus: {
            default: '#2aa198',
        },
    },
    'dark',
);

function Contacts() {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [showModal, setShowModal] = useState(false)
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(20);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [controller] = useMaterialUIController();
    const { darkMode, sidenavColor } = controller;
    const { barColor, tableBorder } = getColorMappings(sidenavColor);
    const [resetClicked, setResetClicked] = useState(false);
    const [screenAccess, setScreenAccess] = useState(false);
    const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
    const [token, setToken] = useState(sessionStorage.getItem("TOKEN"));
    const [values, setValues] = useState({
        _id: [],
        sortingType: "",
        sortingField: "",
        contactType: "All",
        filterValues: "",
        page: appConstants.page,
        limit: appConstants.limit,
        searchParameterList: ['name', 'contactType', 'companyName', 'streetAddress', 'emailAddress', 'accountNumber', 'phoneNumber', 'abnNumber'],
        businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))?.businessUserID,
        token: token
    });
    const [tabledata, setTableData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
                await getRight();
                await fetchContactReport();
            } catch (error) {
                console.error("Error in useEffect:", error.message);
            }
        };
        fetchData();
    }, [perPage]);

    const headers = [
        { label: "Name", key: "name" },
        { label: "Contact Type", key: "contactType" },
        { label: "Email Address", key: "emailAddress" },
        { label: "Address", key: "streetAddress" },
        { label: "Company Name", key: "companyName" },
        { label: "Mobile Number", key: "phoneNumber" },
        { label: "ABN", key: "abnNumber" },
    ];

    async function getRight() {
        SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
        console.log("Report", SCREEN_RIGHT)
        setScreenAccess(SCREEN_RIGHT === 'Full Access');
    }

    function exportSwal() {
        setShowModal(false);
        showResMsg(genericMessage.dataExportedSucces, 1000, true)
    }

    const ResetData = () => {
        setValues((prevValues) => ({
            ...prevValues,
            searchParameter: "",
            page: appConstants.page,
            limit: appConstants.limit,
            sortingType: "",
            sortingField: "",
            filterValues: "",
            contactType: "All",
            searchParameterList: ['contactName', 'contactType', 'companyName', 'streetAddress', 'emailAddress', 'accountNumber', 'phoneNumber', 'phoneNumber', 'abnNumber'],

        }));
        setResetClicked(true);
    };

    const fetchContactReport = async () => {
        values.perPage = perPage;
        fetchContactReportDetails(values, (data) => {
            if (data) {
                setTotalRows(data.result.Result_Output.totalDocs)
                setRows(data.result.Result_Output.docs);
                setTableData(data.result.export);
            }
        }, dispatch);

        //         // When fetching data
        // fetchContactReportDetails(values, (data) => {
        //     if (data) {
        //         setTotalRows(data.result.Result_Output.totalDocs);
        //         setRows(data.result.Result_Output.docs);

        //         // Sort export data by name ascending (A → Z)
        //         const sortedExport = [...data.result.export].sort((a, b) => 
        //             a.name.localeCompare(b.name)
        //         );
        //         setTableData(sortedExport);
        //     }
        // }, dispatch);

    }
    const FilterData = async () => {
        fetchContactReport();
    };

    useEffect(() => {
        if (resetClicked) {
            fetchContactReport();
            setResetClicked(false);
        }
    }, [resetClicked]);

    const handleSearchFilter = (event) => {
        setValues({ ...values, filterValues: event.target.value });
    };

    const handleSort = async (type, value) => {
        values.sortingType = value;
        values.sortingField = type;
        await fetchContactReport();
    };

    const handlePageChange = page => {
        values.page = page;
        fetchContactReport();
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setLoading(true);
        values.page = page;
        values.limit = newPerPage
        setPerPage(newPerPage);
        setLoading(false);
    };

    let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
    if (changePaginationText !== undefined) {
        changePaginationText.getElementsByTagName('span')[0].textContent = "Records Per Page";
    }
    // var element = document.getElementsByTagName('fieldset');
    // useEffect(() => {
    //     for (let i = 0; i < element.length; i++) {

    //         if (darkMode) {
    //             element[i].style.borderColor = "white";
    //         } else {
    //             element[i].style.borderColor = tableBorder;
    //         }

    //     }
    // }, [showFilters])



    useEffect(() => {
        var element = document.getElementsByTagName('fieldset');
        let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
        for (let i = 0; i < element.length; i++) {

            element[i].style.borderColor = darkMode ? "white" : tableBorder;
        }

        for (let i = 0; i < labelShrink.length; i++) {
            labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
        }
    }, [showFilters])


    useEffect(() => {
        var dropicons = document.querySelectorAll('.MuiInputBase-root');
        for (let i = 0; i < dropicons.length; i++) {
            var svgicon = dropicons[i].getElementsByTagName('svg');
            if (svgicon.length > 0) {
                if (darkMode) {
                    svgicon[0].setAttribute("style", "fill: white !important;");
                } else {
                    svgicon[0].setAttribute("style", "");
                }
            }
        }

    }, [showFilters])


    let columns = [
        {
            // name: "Name",
            name: <p style={{ fontSize: "12px" }}>Name</p>,
            selector: row => row.name,
            sortable: true,
            sortField: 'name',
        },
        {
            // name: "Contact Type",
            name: <p style={{ fontSize: "12px" }}>Contact Type</p>,
            selector: row => row.contactType,
            sortable: true,
            sortField: 'contactType',
            center: true,

        },
        {
            // name: "Email Address",
            name: <p style={{ fontSize: "12px" }}>Email Address</p>,
            selector: row => (<Tooltip title={row.emailAddress} arrow>
                <span>{row.emailAddress}</span>
            </Tooltip>),
            sortable: true,
            sortField: 'emailAddress',
        },
        {
            // name: "Address",
            name: <p style={{ fontSize: "12px" }}>Address</p>,
            selector: row => (<Tooltip title={row.streetAddress} arrow>
                <span>{row.streetAddress}</span>
            </Tooltip>),
            sortable: true,
            sortField: 'streetAddress',
            center: true,
            minWidth: "250px"
        },
        {
            // name: "Company Name",
            name: <p style={{ fontSize: "12px", textAlign: "center" }}>Company Name</p>,
            selector: row => row.companyName || '',
            sortable: true,
            style: { textAlign: "center" },
            sortField: 'companyName',
            center: true,
        },
        // {
        //     name: "Company Account Number",
        //     selector: row => row.accountNumber || '',
        //     sortable: true,
        //     sortField: 'accountNumber',
        //     center: true,
        // },
        {
            // name: "Mobile Number",
            name: <p style={{ fontSize: "12px" }}>Mobile Number</p>,
            selector: row => row.phoneNumber,
            sortable: true,
            sortField: 'phoneNumber',
            center: true,
        },
        {
            // name: "ABN",
            name: <p style={{ fontSize: "12px" }}>ABN</p>,
            selector: row => row.abnNumber,
            sortable: true,
            sortField: 'abnNumber',
            center: true,
        }
    ];



    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ marginTop: '20px' }}>
                <Card color="primary">
                    <PageTitle screenName="Contacts Report" />

                    <Grid container columnSpacing={2} px={2} mt={1} alignItems="center" display="flex" justifyContent="right">

                        <Grid item xs={12} md={4} spacing={2} lg={1.4}  >
                            <MDButton
                                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                                color={"warning"}
                                fullWidth
                                onClick={() => { setShowFilters(!showFilters) }}
                                style={{ height: "38.11px" }}
                            >
                                {showFilters ? 'Hide Filters' : 'Set Filters'}

                            </MDButton>
                        </Grid>

                        <Grid item xs={12} md={4} spacing={2} lg={1.4} >
                            {screenAccess ?
                                <MDButton
                                    className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                                    style={{ backgroundColor: "#009cff", color: "#ffffff", height: "38.11px" }}
                                    fullWidth
                                    onClick={() => { setShowModal(true) }}
                                >
                                    Export
                                </MDButton>
                                :
                                <MDButton
                                    className
                                    ={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                                    style={{ height: "38.11px" }}
                                    color={"secondary"}
                                    fullWidth

                                >
                                    Export
                                </MDButton>
                            }
                        </Grid>
                    </Grid>
                    {showFilters && (
                        <MDBox>
                            <Grid item xs={12} >
                                <MDBox px={2} pt={1}>
                                    <Grid container columnSpacing={2} px={4} py={2} justifyContent="end">

                                        <Grid lg={2.5} xs={6} >
                                            <FormControl fullWidth>
                                                <InputLabel id="Status">Filter By Contact Type</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    style={{ height: "38.11px" }}
                                                    label="Filter By Contact Type"
                                                    value={values.contactType}
                                                    onChange={(e) => setValues({ ...values, contactType: e.target.value })}
                                                >
                                                    <MenuItem value="All">All</MenuItem>
                                                    <MenuItem value="Customer">Customer</MenuItem>
                                                    <MenuItem value="Supplier">Supplier</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} lg={3}>
                                            <TextField
                                                type="text"
                                                variant="outlined"
                                                fullWidth
                                                className="searchButton"
                                                placeholder="Search..."
                                                label="Search Filter"
                                                value={values.filterValues}
                                                onChange={handleSearchFilter}
                                                onKeyUp={(e) => {
                                                    if (e.key === "Enter") fetchContactReport();
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment  >
                                                            <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchContactReport}>
                                                                <GridSearchIcon color="white" />
                                                            </Button>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                                            <Link to={"/contactReport"}>
                                                <MDButton
                                                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                                                    color="warning"
                                                    fullWidth
                                                    onClick={ResetData}
                                                    style={{ height: "38.11px" }}
                                                >
                                                    Reset
                                                </MDButton>
                                            </Link>
                                        </Grid>

                                        <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                                            <MDButton
                                                rel="noreferrer"
                                                variant="gradient"
                                                color="success"
                                                fullWidth
                                                onClick={FilterData}
                                                style={{ height: "38.11px" }}
                                            >
                                                Apply
                                            </MDButton>
                                        </Grid>

                                    </Grid>
                                </MDBox>
                            </Grid>
                        </MDBox>
                    )}
                    {/* <CardContent> */}
                    <BTable
                        columns={columns}
                        data={rows}
                        sortingType={handleSort}
                        sortServer
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}

                    />
                    {/* </CardContent> */}
                </Card>
            </div>
            {showModal &&
                < Modal
                    open={showModal}
                    onClose={() => setShowModal(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Card sx={style}>
                        <Box>
                            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>
                                <HelpIcon style={{ color: "red" }} />
                            </Typography>
                            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black" }}>
                                Would you like to export this record?
                            </Typography>
                            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                                <>
                                    <MDButton className="no-button" onClick={() => { setShowModal(false) }} sx={{ width: "64px", textTransform: "capitalize" }}>
                                        No
                                    </MDButton>
                                </>
                                &nbsp; &nbsp;
                                <>
                                    <CSVLink data={tabledata} headers={headers} filename={"Contacts Report (" + (new Date().toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })) + ") .csv"}>
                                        <MDButton className="yes-button" onClick={() => { exportSwal() }} sx={{ width: "64px", textTransform: "capitalize" }}>
                                            Yes
                                        </MDButton>

                                    </CSVLink>
                                </>
                            </Grid>
                        </Box>
                    </Card>
                </Modal>
            }



        </DashboardLayout>
    );

}

export default Contacts;
